<div class="row g-3">
    <div class="col-sm-2 offset-sm-8">
        <ed-button
            [colorSchema]="buttonColors.Secondary"
            (click)="addSubcontractorInvoice()"
            [disabled]="!project"
        >
            Importer des factures
        </ed-button>
    </div> <div class="col-sm-2">
        <ed-button
            [colorSchema]="buttonColors.Secondary"
            (click)="addSubcontractorInvoiceRecurrence()"
            [disabled]="!project"
        >
            Anticiper une récurrence
        </ed-button>
    </div> 
</div>
<br/>
<div class="row g-3">
    <div class="col-sm-12">
        <ed-table
                title="Planning de facturation sortante"
                [dataSource]="subcontractorInvoiceData" 
                [displayedColumns]="subcontractorInvoiceColumns"
                [sortInfo]="{field: 'plannedDate', order: -1}"
                [areActionsInElements]="true"
                (onDropdownMenuClick)="onActionClicked($event.object, $event.event)"
                (onRowClick)="updateSubcontractorInvoice($event)"
                >
            </ed-table>
    </div>
</div>

